// removed by extract-text-webpack-plugin
module.exports = {"bannerContainer":"bannerContainer--2yzJL","bannerWrapper":"bannerWrapper--1XFDR","left":"left--2b_V7","right":"right--2PFBF","close":"close--sfp5A","appIcon":"appIcon--3iaPN","details":"details--3-9L2","title":"title--1SZQn","description":"description--2IiSE","badge":"badge--XZMtM","hitbox":"hitbox--3dXBk"};


/*****************
 ** WEBPACK FOOTER
 ** ./apps/storePages/branch/components/branchBanner.scss
 ** module id = 1479
 ** module chunks = 15
 **/